import React from 'react';
import { Archive, Edit2 } from 'react-feather';

function AssetsGrid({ formData, onDataChange }) {
  return (
    <div className="form-section" style={{ marginTop: '2rem' }}>
      <div className="content-box-header">
        <h2><Archive size={20} className="icon-orange" /> Assets & Depreciation</h2>
      </div>

      <div className="dependent-card">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <Edit2 size={16} className="icon-blue" />
          <label style={{ fontWeight: 600, color: '#554933ff', margin: 0 }}>Total Depreciation</label>
        </div>
        <p style={{ fontSize: '0.9rem', color: '#8b7564ff', marginBottom: '1rem' }}>
          Enter the total annual depreciation deduction for your business assets (Form 4562).
        </p>
        <div className="form-group">
          <label>Annual Depreciation Deduction</label>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="manualDepreciation" 
              value={formData?.manualDepreciation ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default AssetsGrid;